import { secureGetJson } from "./MyFetch";

export interface ConfigDTO {
    id:number
    name:string
    value:string
    comment:string
}

export async function getAllConfigs():Promise<ConfigDTO[]> {
    return secureGetJson('/api/config');
}
